import IndexLayout from "../Layouts/IndexLayout";
import MainLayout from "../Layouts/MainLayout";
import PagesLayaut from '../Layouts/PagesLayaut'
import { createBrowserRouter } from "react-router-dom";
import Productos from '../Pages/Productos/Productos'
import Usuarios from '../Pages/Usuarios/Usuarios'
import Banners from "./Banners/Banners";
import Diseno from "./Diseno/Diseno";
import Main from "./Main/Main";
import Contacto from "./Contacto/Contacto";
import Categorias from "./Categorias/Categorias";
import Codigos from "./Codigos/Codigos";
import PageDetail from '../Pages/PageDetail/PageDetail';
import PageProductos from "./PageProductos/PageProductos";
import Pedidos from "./Pedidos/Pedidos";
import SupportTickets from "./SupportTickets/SupportTickets";
import RecuperarContrasena from "./RecuperarContrasena/RecuperarContrasena";
import RestablecerContrasena from "./RestablecerContrasena/RestablecerContrasena";
import MiCuenta from "./MiCuenta/MiCuenta";
import StoreContent from "./StoreContent/StoreContent";
import ConfirmarCuenta from "./ConfirmarCuenta/ConfirmarCuenta";
export const router = createBrowserRouter([
    {
        path: "/recuperar-contrasena",
        element: <RecuperarContrasena />,
    },
    {
        path: "/restablecer-contrasena",
        element: <RestablecerContrasena />,
    },
    {
        path: "/confirmar-cuenta",
        element: <ConfirmarCuenta />,
    },

    {
        path: "/",
        element: <IndexLayout />,

    },
    {
        path: "/",
        element: <PagesLayaut />,
        children: [
            {
                path: `/producto/:idProducto/:producto`,
                element: <PageDetail />,
            },
            {
                path: `/productos`,
                element: <PageProductos />,
            },
            {
                path: `/mi-cuenta`,
                element: <MiCuenta />,
            },
            {
                path: `/soporte`,
                element: <StoreContent />,
            },
            {
                path: `/entregas`,
                element: <StoreContent />,
            },
            {
                path: `/devoluciones`,
                element: <StoreContent />,
            },
            {
                path: `/terminos-y-condiciones`,
                element: <StoreContent />,
            },

        ]
    },
    {
        path: "/",
        element: <MainLayout />,
        children: [
            {
                path: `/dashboard`,
                element: <Main />,
            },
            {
                path: `/dashboard/productos`,
                element: <Productos />,
            },
            {
                path: `/dashboard/usuarios`,
                element: <Usuarios />,
            },
            {
                path: `/dashboard/banners`,
                element: <Banners />,
            },
            {
                path: `/dashboard/diseno`,
                element: <Diseno />,
            },
            {
                path: `/dashboard/contacto`,
                element: <Contacto />,
            },
            {
                path: `/dashboard/categorias`,
                element: <Categorias />,
            },

            {
                path: `/dashboard/codigos`,
                element: <Codigos />,
            },
            {
                path: `/dashboard/pedidos`,
                element: <Pedidos />,
            },
            {
                path: `/dashboard/tickets-soporte`,
                element: <SupportTickets />,
            },
        ],
    },


]);
